namespace AgerLMS.LMS {
    export interface SpecificationRow {
        SpecificationId?: number;
        Title?: string;
        InputType?: SpecificationInputTypes;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace SpecificationRow {
        export const idProperty = 'SpecificationId';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'LMS.Specification';
        export const deletePermission = 'LMS';
        export const insertPermission = 'LMS';
        export const readPermission = 'LMS';
        export const updatePermission = 'LMS';

        export declare const enum Fields {
            SpecificationId = "SpecificationId",
            Title = "Title",
            InputType = "InputType",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
